module.exports = __webpack_public_path__ + "static/img/2.bc28179.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/docs/image/2.png
// module id = 677
// module chunks = 1